import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { PropertyTypeValue, initPropertyTypeMap } from '@miq/utils';

/**
 * Centralized service to load MIQ property usage types
 * and seed the global PROPERTY_TYPE_MAP.
 */
@Injectable({ providedIn: 'root' })
export class PropertyUsageTypeService {
  private readonly endpoint = '/api/lookup/ref/country?lookupcategory=miq_property_usage';
  private propertyTypes$?: Observable<PropertyTypeValue[]>;

  constructor(private http: HttpClient) {}

  /**
   * Returns the raw list of property usage types from the backend.
   * Callers can subscribe or use | async if they need the list.
   */
  getPropertyTypes(): Observable<PropertyTypeValue[]> {
    if (!this.propertyTypes$) {
      this.propertyTypes$ = this.http.get<PropertyTypeValue[]>(this.endpoint).pipe(
        tap(values => initPropertyTypeMap(values || [])),
        shareReplay(1)
      );
    }
    return this.propertyTypes$;
  }
}
